import UnregisterRouter from './router/unregister-router';

export default UnregisterRouter;
